// extracted by mini-css-extract-plugin
export default {"input":"style_input__WvuPt","rich":"style_rich__mp-5L","form":"style_form__uv5IN"};